import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UsuarioService } from './usuario.service';
import { URL_SERVICIOS  } from '../config/config';

import { throwError } from 'rxjs';
import { map , catchError } from 'rxjs/operators';
 
@Injectable({
    providedIn: 'root'
  })
  
export class SharedService {

  constructor(public _http: HttpClient,
              public _usuario : UsuarioService) {
  }

  getPAD10COD() : string {
    return this._usuario.getPAD10COD();
  }

  getS00NOM() : string {
    return this._usuario.getS00NOM();
  }

  getM12CAR() : string {
    return this._usuario.getM12CAR();
  }

  getToken() : string {
    return this._usuario.token;
  }

  getHeaders(){
    let strCNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    let strM05COD   = localStorage.getItem("X-AVATAR-M05COD");
    
    if (strCNT05COD == null) strCNT05COD = "??";
    if (strM05COD == null)   strM05COD = "??";

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append ("X-AVATAR-CNT05COD", strCNT05COD);
    headers = headers.append ("X-AVATAR-M05COD", strM05COD);
    headers = headers.append ("Authorization", "Bearer " + this._usuario.token);
    return headers;
  }

  Consultar ( url : string, params? : string ) {
        let headers = this.getHeaders();

        if (params === void 0) { 
          params = JSON.parse('{  }');          
        }

        url = URL_SERVICIOS + url ;

        return this._http.post( url , params, { headers : headers } )
              .pipe(map( (resp: any) => {
                return resp.DATA;
              }),
              catchError( err => {
                console.log ("Error Al consultar ", err );
              if (err.status == "401"){
                return throwError(() => err);
              } else if (err.status == "404"){
                return throwError(() => err);
              } else {
                return throwError(() => err);
              }
            }));
    }


  ConsultarWS ( url : string, params? : string, btn?) {
        if(btn != undefined) btn.disabled = true;
        let headers = this.getHeaders();

        if (params === void 0) { 
          params = JSON.parse('{  }');          
        }

        url = URL_SERVICIOS + url ;

        return this._http.post( url , params, { headers : headers } )
              .pipe(map( (resp: any) => {
                if(btn != undefined) btn.disabled = false;
                return resp;
              }),
              catchError( (err) => {
                console.log ("Error Al ConsultarWS ", err );
                if(btn != undefined) btn.disabled = false;
              if (err.status == "401"){
                return throwError(() => err);
              } else if (err.status == "404"){
                return throwError(() => err);
              } else {
                return throwError(() => err);
              }
            }));
    }    

  Ejecutar (url : string, jsonobject?: any, params? : string) {
    let headers = this.getHeaders();

    if (jsonobject === void 0) { 
      jsonobject = JSON.parse('{  }');          
    } 

    if (params === void 0) { 
      params = '';          
    } 

    url = URL_SERVICIOS + url + ( params=='' ? '' : ('?' + params)); 
    return this._http.post( url, jsonobject , { headers : headers } )
                .pipe(map( (resp: any) => {
                  return resp.DATA;
                }),
                catchError( err => {
                  console.log ("Error Al Ejecutar ", err );
    
                  if (err.status == "401"){
                    return throwError(() => err);
                  } else if (err.status == "404"){
                    return throwError(() => err);
                  } else {
                    return throwError(() => err);
                  }
                }));                  
  }

  GenerarReporteDinamico ( intSYS02CON: string, intSYS10CON: string, intTSTAMP: string, strFORMATO? : string, params? : any) {
    let parametros = '';
    if (params === void 0) { 

    } else {
      /*
console.log ('Generar Reporte', params.LLAVES.FILTROS_OPCIONALES.length);
      let par = params.LLAVES.FILTROS_OPCIONALES;
//      for (let i = 0; i < par.length; i++) {
  //              parametros = parametros + "&" + par[i][0] + "=" + par[i][1];
    //  }

      par.forEach( (element) => {
        console.log(element);
        let item of objectKeys(element);
        item.forEach( (element2) => {
          parametros = parametros + "&" + element2 + "=" + item.element2;
        });
      });
      */
    } 

    if (strFORMATO === void 0) strFORMATO = "PDF";

    alert('Falta resolver el paso de parámetros');

    return URL_SERVICIOS +  "app/ReportesDinamicos.jsp?SYS02CON=" + intSYS02CON 
                                                    + "&SYS10CON=" + intSYS10CON 
                                                    + "&TSTAMP=" + intTSTAMP
                                                    + "&FORMATO=" + strFORMATO
                                                    + parametros ;
  }


}
